module.exports = __webpack_public_path__ + "static/img/LOGO-珠西科学城.6891adf1.png";